export default __webpack_public_path__ + "static/media/hourglass-light.902ec842.svg";